// extracted by mini-css-extract-plugin
export default {"vSub":"style-module--v-sub--Reb+G","imageCompanyLogo":"style-module--imageCompanyLogo--ExzR1","modalClass":"style-module--modalClass--0CxXO"};